import type { IDescriptions } from './types'

export const getDescriptionsApi = () => {
  return import.meta.env.VITE_DESCRIPTION_API_URL
}

export const convertDescriptionResponseToObject = (data: any): IDescriptions => {
  return {
    year: data?.year ?? '',
    make: data?.make ?? '',
    model: data?.model ?? '',
    trim: data?.trim ?? '',
    a5: data?.a5 ?? { value: '' },
    ai2: data?.ai2 ?? { value: '' },
    default: data?.default ?? { value: '' },
  }
}

export const getEmptyDescriptionsTemplate = (): IDescriptions => {
  return {
    year: '',
    make: '',
    model: '',
    trim: '',
    default: {
      value: '',
    },
    ai2: {
      value: '',
    },
    a5: {
      value: '',
    },
  }
}
